import React, { useState } from "react";
import { Col, Row, Container, Button } from "react-bootstrap";
import FormInput from "../../../Components/Shared/FormInput";
import { fetchNearbyCities, formatPopulation } from "../../../utils/cityUtils";

export const AdminDemoCities = () => {
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [population, setPopulation] = useState(10000);
  const [radius] = useState(1);
  const [maxResults, setMaxResults] = useState(10);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("population");

  const handleFetchCities = async () => {
    setLoading(true);
    setResults([]);

    try {
      const cities = await fetchNearbyCities(
        city,
        state,
        "US",
        population,
        radius,
        maxResults
      );
      setResults(cities);
    } catch (error) {
      alert(error.message || "Failed to fetch data");
    }
    setLoading(false);
  };

  return (
    <>
      <Container>
        <h1 className="page-title">Find Nearby Cities</h1>
        <div className="dashboard-wrapper">
          <Row className="justify-content-md-center">
            <Col sm={12} md={6} className="mt-0">
              <div className="dashboard-box dashboard-col-bg mb-4">
                <h2 className="sub-form-title mb-6 d-flex">
                  Find Nearby Cities
                </h2>

                <label htmlFor="city">City</label>
                <FormInput
                  type="text"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e)}
                  className="block w-full p-2 border rounded mb-2"
                  id="city"
                />

                <label htmlFor="state">State</label>
                <div className="form-group mb-2">
                  <select
                    id="state"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    className="inputclass form-control"
                  >
                    <option value="">Select a state</option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>

                <label htmlFor="population">Min Population</label>
                <FormInput
                  type="number"
                  placeholder="Min Population"
                  value={population}
                  onChange={(e) => setPopulation(e)}
                  className="block w-full p-2 border rounded mb-2"
                  id="population"
                />

                <label htmlFor="maxResults">Max Results</label>
                <FormInput
                  type="number"
                  placeholder="Max Results"
                  value={maxResults}
                  onChange={(e) => setMaxResults(e)}
                  className="block w-full p-2 border rounded mb-2"
                  id="maxResults"
                />

                {/* <label htmlFor="radius">Radius (degrees)</label>
                <FormInput
                  type="number"
                  placeholder="Radius"
                  value={radius}
                  onChange={(e) => {
                    if (e > 3) {
                      alert("Max radius is 3");
                      setRadius(3);
                    }
                    if (e < 0) {
                      alert("Min radius is 0");
                      setRadius(0);
                    } else {
                      setRadius(e);
                    }
                  }}
                  className="block w-full p-2 border rounded mb-2"
                  id="radius"
                /> */}

                <label htmlFor="sortBy">Sort By</label>
                <div className="form-group mb-2">
                  <select
                    id="sortBy"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="inputclass form-control"
                  >
                    <option value="population">Population (Highest First)</option>
                    <option value="distance">Distance (Closest First)</option>
                  </select>
                </div>

                <Button
                  onClick={handleFetchCities}
                  className="mt-3"
                  disabled={loading || !city || !state}
                >
                  {loading ? "Loading..." : "Search"}
                </Button>

                <ul className="mt-4">
                  {results
                    .slice()
                    .sort((a, b) => {
                      if (sortBy === "distance") {
                        return (a.distance || 0) - (b.distance || 0);
                      } else {
                        return (b.population || 0) - (a.population || 0);
                      }
                    })
                    .map((city, index) => (
                      <li key={index} className="p-2 border-b">
                        <strong>{city.name}</strong>: Population:{" "}
                        <strong>{formatPopulation(city.population)}</strong> |
                        Distance: <strong>{city.distance?.toFixed(2)}</strong>{" "}
                        miles
                      </li>
                    ))}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
